import type { TPoint } from '@vlabs/monokit/shared/types/regions';

// превращает массив точек {x,y} в плоский массив чисел [x1, y1, x2, y2, ...]
// именно такой формат ждёт react-konva в пропе <Line points={...}>
export const flatten = (pts: TPoint[]) => pts.flatMap((p) => [p.x, p.y]);

// находит вершину с минимальным y (самая верхняя), чтобы привязать Label к «верхней» точке
export const nearestTopPoint = (pts: TPoint[]) => {
  if (!pts?.length) return { x: 0, y: 0 };
  const top = pts.reduce((acc, p) => (p.y < acc.y ? p : acc), pts[0]);
  return top;
};

export const setAlphaChannelInColor = (color: string, alphaChannel: number) => {
  return `rgb(from ${color} r g b / ${alphaChannel})`;
};
